import { createSlice } from "@reduxjs/toolkit";
import { receipts as initialState } from "../initialState";
import fetchReceiptAction from "../actions/receiptActions";

export const slice = createSlice({
    name: "receipts",
    initialState,
    reducers: {
        fetchReceipt: fetchReceiptAction,
    },
});

// actions
export const { fetchReceipt } = slice.actions;

// selectors

// Same as getReceipt

export const selectReceipt = (state) => {
    const { receiptId } = state.receipts;
    return state.receipts[receiptId];
};

export const selectReceiptId = (state) => state.receipts?.receiptId;

export default slice.reducer;
